import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TreeComponent } from '../../../../../common/components/tree/tree.component';
import { StepsDiagramPosition } from '../../../../../common/models/steps-diagram.model';
import { TreeTag } from '../../../../../common/components/tree/tree-tags/tree-tags.component';

@Component({
  selector: 'lib-step-diagram-tab',
  imports: [TreeComponent],
  templateUrl: './step-diagram-tab.component.html',
  styleUrl: './step-diagram-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class StepDiagramTabComponent {
  positions = input.required<StepsDiagramPosition[]>();
  tags = input.required<TreeTag[]>();
  requestName = input.required<string>();
  active = input.required<boolean>();
  tagsChanged = output<string>();
}
